/**
 * @generated SignedSource<<f06f7f1ebf74ba5ce9f9a3159158b585>>
 * @relayHash abcecbee2d472915c1e43640f0e10568
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca3eefa1749696961d1abd1ad7ca8da2cfbb7e58d9a99457813f1b1322f2e2cd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ca3eefa1749696961d1abd1ad7ca8da2cfbb7e58d9a99457813f1b1322f2e2cd",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
